import request from '@/utils/request'
// 考生登录
export function login(userInfo) {
    let params = { ...userInfo }
  params.rememberMe = userInfo.rememberMe ? '1' : '0';
  return request({
    url: '/student/stLogin',
    method: 'post',
    data: params
  })
}
// 登录方法
// export function login(userInfo) {
//   let params = { ...userInfo }
//   params.rememberMe = userInfo.rememberMe ? '1' : '0';
//   return request({
//     url: '/auth/login',
//     method: 'post',
//     data: params
//   })
// }

// 获取用户详细信息
export function getInfo() {
  return request({
    url: '/api/center/findUserDetail',
    method: 'post',
    data: {}
  })
}

// 退出方法
export function logout() {
  return request({
    url: '/logout',
    method: 'post',
    data: {}
  })
}


// 获取公钥
export function getKeys() {
  return request({
    url: '/api/security/getKey',
    method: 'post',
    data: {},
    openLoading: false
  })
}

// 获取图像验证码
export function getCodeImg() {
  return request({
    url: '/verify',
    method: 'post',
    data: {},
    openLoading: false
  })
}